import { render } from "./chatList.vue?vue&type=template&id=63a9cea0&scoped=true"
import script from "./chatList.vue?vue&type=script&lang=js"
export * from "./chatList.vue?vue&type=script&lang=js"

import "./chatList.vue?vue&type=style&index=0&id=63a9cea0&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-63a9cea0"]])

export default __exports__